type LocalizedValue = Record<string, string>

type MeiliSettings = Record<string, unknown> | undefined

/**
 * Meili documents expose both general and currency-suffixed setting keys,
 * e.g. `min_rate` alongside `min_rate_usd`. Localized values arrive as { ru, ky }.
 */
export function useMeiliCurrencySettings(activeCurrency: MaybeRefOrGetter<string | undefined>) {
  const { locale } = useI18n()

  const settingKey = (base: string) => {
    const currency = toValue(activeCurrency)
    return currency ? `${base}_${currency}` : base
  }

  const localizedSetting = (settings: MeiliSettings, key: string): string | undefined => {
    const value = settings?.[key] as LocalizedValue | undefined
    return value?.[locale.value]
  }

  const numericSetting = (settings: MeiliSettings, key: string): number => {
    return Number(settings?.[key] ?? 0)
  }

  return { settingKey, localizedSetting, numericSetting }
}
